import React, {Component} from "react";
import {Container, Row, Col, CardGroup, Card, CardBlock, Button, Input, InputGroup, InputGroupAddon} from "reactstrap";
import AuthService from '../../../components/AuthService';
import 'react-toastify/dist/ReactToastify.css';
import LoginNotificationSystem from '../Login/LoginNotificationSystem';

class Lock extends Component {

    handleLogout(){
        localStorage.removeItem('id_token');
        this.props.history.replace('/login');

    }


    constructor(){

        super();
        this.handleChange = this.handleChange.bind(this);
        this.handleFormSubmit = this.handleFormSubmit.bind(this);
        this.Auth = new AuthService();

    }
    componentWillMount(){



    }
    componentDidMount() {
        this.setState(
            {
                username: '',
                password: ''
            });
    }

    render() {
        return (
            <div className="app flex-row align-items-center">
                <Container>
                    <LoginNotificationSystem ref="notification"/>
                    <Row className="justify-content-center">
                        <Col md="8">
                            <CardGroup className="mb-0">
                                <form onSubmit={this.handleFormSubmit}>
                                    <Card className="p-4">
                                        <CardBlock className="card-body">
                                            <h1>Lock Screen</h1>
                                            <p className="text-muted">Your screen is currently locked, please enter your password to unlock.</p>
                                            <InputGroup className="mb-3">
                                                <InputGroupAddon><i className="icon-user"></i></InputGroupAddon>
                                                <Input type="text" placeholder="Username" name="username" onChange={this.handleChange}/>
                                            </InputGroup>
                                            <InputGroup className="mb-4">
                                                <InputGroupAddon><i className="icon-lock"></i></InputGroupAddon>
                                                <Input type="password" placeholder="Password" name="password" onChange={this.handleChange}/>
                                            </InputGroup>
                                            <Row>
                                                <Col xs="6">
                                                    <Button color="primary" className="px-4" value="SUBMIT" type="submit">Unlock</Button>
                                                </Col>
                                                <Col xs="6" className="text-right">
                                                </Col>
                                            </Row>
                                        </CardBlock>
                                    </Card>
                                </form>

                                <Card className="text-white bg-primary py-5 d-md-down-none" style={{ width: 44 + '%' }}>
                                    <CardBlock className="card-body text-center">
                                        <div>
                                            <h2></h2>
                                            <p>If you would like to switch users, please click the switch user button below</p>
                                            <Button onClick={this.handleLogout.bind(this)} color="primary" className="mt-3" active>Switch User</Button>
                                        </div>
                                    </CardBlock>
                                </Card>
                            </CardGroup>
                        </Col>
                    </Row>
                </Container>
            </div>
        );
    }

    handleFormSubmit(e){
        e.preventDefault();



        if (this.state.username === '') {
            this.refs.notification.notify('Username is required.','error');
        }
        else if(this.state.password === '') {
            this.refs.notification.notify('Password is required. If you have lost your login credentials please notify our support desk.','error');
        }
        else {
            this.Auth.login(this.state.username,this.state.password)
                .then(res =>{
                    this.props.history.replace('/');
                })
                .catch(err =>{
                    alert(err);
                })
        }

    }

    handleChange(e){
        console.log(e.target.name)
        this.setState(
            {
                [e.target.name]: e.target.value
            }
        )
    }
}

export default Lock;



// WEBPACK FOOTER //
// ./src/views/Pages/Lock/Lock.js